<h2>Account Balance {{ (combinedCard$ | async) |  FortressCurrencyPipe }}</h2>
